import type {TeamSort} from "./teamFilters";

export type TeamView = 'grid' | 'list';

export interface TeamViewPrefs {
    view: TeamView;
    sort: TeamSort;
    grouped: boolean;
}

export const DEFAULT_TEAM_VIEW_PREFS: TeamViewPrefs = {view: 'grid', sort: 'name', grouped: false};

const storageKey = (userId: string | number) => `teamViewPrefs:${userId}`;

// Storage can be missing, full or blocked (private mode); the Team tab must
// still render, so every failure falls back to the defaults.
export const readTeamViewPrefs = (userId: string | number | null | undefined): TeamViewPrefs => {
    if (userId === null || userId === undefined || userId === '') return DEFAULT_TEAM_VIEW_PREFS;
    try {
        const raw = localStorage.getItem(storageKey(userId));
        if (!raw) return DEFAULT_TEAM_VIEW_PREFS;
        const stored = JSON.parse(raw) as Partial<TeamViewPrefs>;
        return {
            view: stored.view === 'list' ? 'list' : 'grid',
            sort: stored.sort === 'status' ? 'status' : 'name',
            grouped: stored.grouped === true,
        };
    } catch {
        return DEFAULT_TEAM_VIEW_PREFS;
    }
};

export const writeTeamViewPrefs = (userId: string | number | null | undefined, prefs: TeamViewPrefs): void => {
    if (userId === null || userId === undefined || userId === '') return;
    try {
        localStorage.setItem(storageKey(userId), JSON.stringify(prefs));
    } catch {
        // Not saving a view preference is harmless; the next visit uses the defaults.
    }
};
